var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_message-text",
    "data-name": "vuesax/bold/message-text",
    transform: "translate(-236 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15,0H5A4.991,4.991,0,0,0,0,4.98v6.98a4.991,4.991,0,0,0,5,4.98H6.5a1.149,1.149,0,0,1,.8.4l1.5,1.99a1.421,1.421,0,0,0,2.4,0l1.5-1.99a1.014,1.014,0,0,1,.8-.4H15a4.991,4.991,0,0,0,5-4.98V4.98A4.991,4.991,0,0,0,15,0ZM11,11.75H5a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Zm4-5H5a.75.75,0,0,1,0-1.5H15a.75.75,0,0,1,0,1.5Z",
    transform: "translate(238 254)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(236 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(260 276) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e10765b67c2654ff716072c6fa7b5944.svg";
export { ForwardRef as ReactComponent };